<template>
  <div class="page-topbar">

  </div>
</template>
<script>
export default {
  name: "pageTopbar",
  props: {
    action: String,
    formData: Array,
    hidderAdd: false
  },
  data () {
    return {
      upload: false,
      visible: false,
      drawerFormItem: this.formData,
      drawerForm: this.$form.createForm(this)
    };
  },
  mounted () { },
  methods: {
    add () {
      this.$emit("addItem");
    },
    reset () {
      this.$emit("reset");
    },
    openSelect () {
      this.visible = true;
    },
    importExcel (data) {
      this.upload = true;
      if (data.file.response) {
        if (data.file.response.success) {
          this.$emit("importExcel");
          this.$success({
            title: "Message",
            content: data.file.response.message
          });
        } else {
          this.$error({
            title: "Message",
            content: data.file.response.message
          });
        }
        this.upload = false;
      }
    },
    afterVisibleChange (val) {
      console.log("visible", val);
    },
    showDrawer () {
      this.visible = true;
    },
    onClose () {
      this.visible = false;
    },
    search () {
      this.drawerForm.validateFields((err, fieldsValue) => {
        this.$emit("search", fieldsValue);
        this.onClose();
      });
    }
  }
};
</script>
<style lang="scss">
@keyframes rotate {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
